module.exports = __webpack_public_path__ + "media/coffee-preferences/select_all_country-6ec548cd.png";